'use client'

import { FC } from 'react'

import { Input } from '../form/input/input'
import { InputWrapper } from '../form/input/input-wrapper'

type NumberRangeValue = {
  min?: number
  max?: number
}

type NumberRangeSubFilterProps = {
  label: string
  value: NumberRangeValue | undefined
  onChange: (value: NumberRangeValue | undefined) => void
}

export const NumberRangeSubFilter: FC<NumberRangeSubFilterProps> = ({
  label,
  value,
  onChange
}) => {
  const handleBoundChange = (bound: 'min' | 'max', raw: string) => {
    const parsed = raw === '' ? undefined : Number(raw)
    const next = {
      ...value,
      [bound]: parsed === undefined || Number.isNaN(parsed) ? undefined : parsed
    }
    onChange(
      next.min === undefined && next.max === undefined ? undefined : next
    )
  }

  return (
    <div
      className="flex items-start gap-2 p-2"
      role="group"
      aria-label={`${label} range`}>
      <label className="flex grow flex-col gap-1 text-xs text-slate-600">
        Min
        <InputWrapper inputSize="sm">
          <Input
            type="number"
            step="any"
            value={value?.min ?? ''}
            onChange={e => handleBoundChange('min', e.currentTarget.value)}
            aria-label={`Minimum ${label.toLowerCase()}`}
          />
        </InputWrapper>
      </label>
      <label className="flex grow flex-col gap-1 text-xs text-slate-600">
        Max
        <InputWrapper inputSize="sm">
          <Input
            type="number"
            step="any"
            value={value?.max ?? ''}
            onChange={e => handleBoundChange('max', e.currentTarget.value)}
            aria-label={`Maximum ${label.toLowerCase()}`}
          />
        </InputWrapper>
      </label>
    </div>
  )
}
